module.exports = __webpack_public_path__ + "media/images/gallery/constellations/triangulum/tri_vis-5dda4632c9e25c81eb1e7471f8dd9871.jpg";